import { makeAutoObservable, runInAction } from 'mobx';

import { requireService } from 'src/packages/di';

export class SoundAlarmService {
  subscribersCounter: number = 0;

  isNotified: boolean = false;

  soundTimer: ReturnType<typeof setInterval> | null = null;

  constructor(private soundService = requireService('soundService')) {
    makeAutoObservable(this);
  }

  private clearSoundInterval() {
    if (this.soundTimer) {
      clearInterval(this.soundTimer);
    }
  }

  private setSoundTimer(timer: ReturnType<typeof setInterval> | null) {
    runInAction(() => {
      this.soundTimer = timer;
    });
  }

  addNewAlert() {
    if (this.subscribersCounter === 0) {
      const timer = setInterval(() => {
        this.soundService.playSound('alert');
      }, 1000);

      this.setSoundTimer(timer);
    }
    runInAction(() => {
      this.subscribersCounter += 1;
    });
  }

  removeAlert() {
    runInAction(() => {
      this.subscribersCounter -= 1;
    });

    if (this.subscribersCounter <= 0) {
      runInAction(() => {
        this.subscribersCounter = 0;
      });
      this.soundService.stopSound('alert');
      this.clearSoundInterval();
      this.setSoundTimer(null);
    }
  }
}
